//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "quasar";
import { mapGetters, mapActions } from "vuex";
import { PLATFORM_BASE_PATH } from "@/assets/js/appConfig";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDataTable from "@/components/Generics/AQDataTable/AQDataTable.vue";
import AQDataColumnSettings from "@/components/Generics/AQDataTable/AQDataColumnSettings.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";
import AQMenu from "@/components/Generics/AQMenu/AQMenu.vue";
import UnclaimReassignModal from "@/components/tasks/unclaimReassign/unclaimReassignModal.vue";
import { EXPORT_MAPPINGS } from "@/pages/main/views/Reports/SearchFiltersReports/constants";
import { eventBus } from "@/assets/js/appFunc";
import { TYPES_TRANSLATE } from "../../PerspectiveBuilder/PerspectiveDetails/const";
import {
    REPORTS_PROPS,
    TABS_CONFIG,
    TABLE_TASKS_CONFIG,
    TABLE_INSTANCES_CONFIG,
    BULK_OPTIONS,
    TASKS_CELLS_PROPS,
    INSTANCES_CELLS_PROPS,
    TASK_STATUSES,
    TABLE_FIXED_COLS,
    TASKS_LOADING_STYLE,
    INSTANCES_LOADING_STYLE,
    DEFAULT_SORT_COLUMNS
} from "./ReportsTable.const";
import ReportsCellCustomBody from "./ReportsCellCustomBody.vue";

/* eslint-disable no-param-reassign */
export default {
    name: "ReportsTasksAndInstances",
    components: {
        AQButton,
        AQTooltip,
        AQDataTable,
        AQDataColumnSettings,
        AQMenu,
        AQCheckbox,
        UnclaimReassignModal,
        ReportsCellCustomBody
    },
    props: {
        ...REPORTS_PROPS
    },
    data() {
        return {
            tabsConfig: [],
            hasStatusPreferences: false,
            showAllItemsSelected: false,
            executedOnSearch: false,
            isOnSwitch: false,
            callOnSearch: false,
            tasksCellsProps: TASKS_CELLS_PROPS,
            instancesCellsProps: INSTANCES_CELLS_PROPS,
            tasksColumns: this.setTasksDefaultColumns(TABLE_TASKS_CONFIG),
            instancesColumns: this.setTasksDefaultColumns(TABLE_INSTANCES_CONFIG),
            taskStatuses: TASK_STATUSES,
            tableFixedCols: TABLE_FIXED_COLS,
            openUnclaimReassign: null,
            hideTasksPagination: false,
            tasksSelection: "none",
            colsToRemove: ["action", "more"],
            showUserActionsReassign: false,
            showUserActionsUnclaim: false,
            actionBulk: [],
            bulkAllModal: false,
            moreActionModel: null,
            isSelectedAll: false,
            counterTasks: 0,
            counterInstances: 0,
            tasksTotalPages: 0,
            instancesTotalPages: 0,
            tasksData: [],
            instancesData: [],
            moreBulkOptions: BULK_OPTIONS,
            hideOptions: false,
            actionsBulkOptions: [],
            localBulkActions: [],
            selectedTab: "tab-tasks",
            isFullScreen: false,
            selectAllTasks: false,
            statusExpandCollapse: "collapse",
            tasksSelectedList: [],
            tasksSelectedIdsList: [],
            resetCurrentPageTasks: false,
            resetCurrentPageInstances: false,
            tasksSortPreferences: { sortType: null, sortBy: null, columns: [] },
            instancesSortPreferences: { sortType: null, sortBy: null, columns: [] },
            tasksInitialSort: null,
            instancesInitialSort: null,
            instancesPagination: {},
            tasksPagination: {},
            loadingTasks: false,
            loadingInstances: false,
            triggerOnSearch: false,
            exportPayload: {
                excelDataModelFields: [],
                searchModel: {},
                processDefinitionId: "",
                isTask: null,
                timezone: ""
            },
            currentSelectedAnchoredData: {},
            tasksFirstLoad: true,
            instancesFirstLoad: true,
            tabsType: TYPES_TRANSLATE,
            payloadTasks: {
                activeTasks: true,
                page: 0,
                searchTerm: "",
                size: 10,
                sortDirection: null,
                sortField: null,
                taskAndInstanceFilterModel: {
                    applicationId: "",
                    processDefinitionId: "",
                    creationDateFrom: "",
                    creationDateTo: "",
                    dataModelFields: [],
                    groupIds: [],
                    priorities: [],
                    taskStatus: [],
                    userIds: []
                }
            },
            customTasksSort: null,
            customInstancesSort: null,
            noTriggerAction: false,
            preferencesError: false,
            hasInitialPage: false,
            searchAction: true,
            clearFilters: false
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        ...mapGetters("diagrams", ["selectedPluginConfigData", "selectedPluginUuid"]),
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("reports", ["getSelectedProcessReports"]),
        changeValueInstActivity() {
            return this.isSearchPage && (this.tasksInstExData.hideRedirectInstance || this.tabsConfig.length === 1);
        },
        enableInstanceNameCol() {
            const hasInstanceTab = this.tabsConfig.find(({ value, visible }) => value === "tab-instances" && visible);
            return this.isSearchPage && (!hasInstanceTab || this.tasksInstExData.hideRedirectInstance);
        },
        isSearchPage() {
            return this.pageType === "searchPerspectives";
        },
        instancesPageName() {
            return this.hasExternalData ? "perspectiveInstances" : "reportsInstances";
        },
        tasksPageName() {
            return this.hasExternalData ? "perspectiveTasks" : "reportsTasks";
        },
        getCurrentSelectedProcess() {
            return this.getSelectedProcessReports[this.pageType];
        },
        checkIfBulk() {
            return ((this.showUserActionsReassign || this.showUserActionsUnclaim) && (this.isOwner || this.hasWriteRT || this.hasWriteUC));
        },
        showFullScreenAction() {
            return this.tasksInstExData ? this.tasksInstExData.showFullScreenBtn : true;
        },
        hideDataModelSettings() {
            return this.tasksInstExData ? !this.tasksInstExData.allowUseSettingsModel : false;
        },
        showInstancesSettings() {
            return (this.instancesData && this.instancesData.length && this.instancesColumns && this.instancesColumns.length);
        },
        checkAllowSettings() {
            return this.tasksInstExData ? this.tasksInstExData.allowSettings : true;
        },
        checkAllowExport() {
            return this.tasksInstExData ? this.tasksInstExData.allowExport : true;
        },

        showTasksSettings() {
            return !(this.isBulkMode || !(this.isExpandStatus || this.isFullScreen))
                && (this.tasksColumns && this.tasksColumns.length) && this.checkIfTableDataTasks;
        },
        setTableTasksInfoCard() {
            let infoMsg = "";
            if (this.tasksSelectedList && this.tasksSelectedList.length) {
                infoMsg = `${this.isSelectedAll ? this.counterTasks : this.tasksSelectedList.length} ${this.$t("liveView.tasksInstances.selected")}`;
            } else {
                infoMsg = this.checkIfTableDataTasks
                    ? `${this.counterTasks} ${this.$t(`liveView.tasksInstances.itemTask${this.counterTasks > 1 ? "s" : ""}`)} - `
                    : `0 ${this.$t("liveView.tasksInstances.itemTasks")}`;
            }
            return infoMsg;
        },
        setTableInstancesInfoCard() {
            let infoMsg = `0 ${this.$t("liveView.tasksInstances.itemInstances")}`;
            if (this.checkIfTableDataInstances) {
                infoMsg = `${this.counterInstances} ${this.$t(`liveView.tasksInstances.itemInstance${this.counterInstances > 1 ? "s" : ""}`)} - `;
            }

            return infoMsg;
        },
        showTableDisplayedTasks() {
            return this.checkIfTableDataTasks && this.tasksSelectedList && !this.tasksSelectedList.length;
        },
        checkIfTableDataTasks() {
            return this.tasksData && this.tasksData.length;
        },
        checkIfTableDataInstances() {
            return this.instancesData && this.instancesData.length;
        },
        getTasksCellProps() {
            return {
                isOwner: this.isOwner,
                hasWriteRT: this.hasWriteRT,
                hasWriteUC: this.hasWriteUC,
                isBulkMode: this.isBulkMode,
                isSearchPage: this.isSearchPage
            };
        },
        getColumnSettTasksProps() {
            return {
                atId: "reports-tasks",
                title: this.$t("dataTable.settingsTitle"),
                columns: this.tasksColumns.filter(col => col.name !== "more"),
                defaultColumns: this.isSearchPage ? this.getDefaultVisibleCols("tasks")
                    : TABLE_TASKS_CONFIG.filter(col => col.name !== "more"),
                dataModelMode: "rp",
                infoTooltip: this.$t("dataTable.tooltipSettings"),
                reorder: true,
                focusScrollEnd: true,
                iconBtn: "tune",
                removeDMOnReset: this.isSearchPage,
                noDataModel: this.hideDataModelSettings,
                keepOneSelected: true,
                expandCatalogues: false
            };
        },
        exportTasksColumns() {
            const columnsToBeDisplayed = JSON.parse(JSON.stringify(this.tasksColumns)).filter(col => !this.colsToRemove.includes(col.name));
            columnsToBeDisplayed.forEach(elem => {
                if (elem.name === "taskName" || elem.name === "status") {
                    elem.required = false;
                } else if (elem.name === "instanceID") {
                    elem.required = true;
                }
            });
            return columnsToBeDisplayed;
        },
        getExportSettTasksProps() {
            return {
                atId: "reports-exports-tasks",
                title: this.$t("dataTable.exportTasksTitle"),
                dataModelMode: "i",
                forceModelUpdate: true,
                columns: this.exportTasksColumns,
                hideDefaultBtn: true,
                labelConfirmButton: this.$t("dataTable.btnExport"),
                iconBtn: "save_alt",
                infoTooltip: this.$t("exportReports.exportTaskInfo"),
                noDataModel: this.hideDataModelSettings,
                expandCatalogues: false
            };
        },
        getTableTasksProps() {
            return {
                atId: "reports-tasks",
                columns: this.tasksColumns,
                tableData: this.tasksData,
                totalPages: this.tasksTotalPages,
                selection: this.tasksSelection,
                hideBottom: !this.isFullScreen || this.hideTasksPagination,
                selectTableRows: this.tasksSelectedList,
                resetCurrentPage: this.resetCurrentPageTasks,
                sortPreferences: this.getSortTasksPreferences,
                loading: this.loadingTasks,
                removeTableBorder: true,
                hideHeaderOnNoData: !this.hasExternalData,
                loadingStyle: TASKS_LOADING_STYLE,
                reduseFromTableHeight: this.getReduceHeight,
                disableRowsSelection: this.isSelectedAll,
                styledTable: true,
                rowColorSeparator: true,
                tableEmptyState: this.searchAction,
                noDescription: this.loadingTasks || !!this.tasksData.length
            };
        },
        getReduceHeight() {
            let retVal = "4px";
            if (this.$slots.beforeHeaderTable) {
                retVal = `${this.reduseFromTableHeight}px`;
            } else if (localStorage.getItem("maintenanceSchedule") === "true") {
                retVal = "115px";
            }
            return retVal;
        },
        getSortTasksPreferences() {
            return this.pageType ? this.tasksInitialSort : this.customTasksSort;
        },
        getColumnSettInstancesProps() {
            return {
                atId: "reports-instances",
                title: this.$t("dataTable.settingsTitle"),
                columns: this.instancesColumns,
                defaultColumns: this.isSearchPage ? this.getDefaultVisibleCols("instances") : TABLE_INSTANCES_CONFIG,
                infoTooltip: this.$t("dataTable.tooltipSettings"),
                dataModelMode: "rpm",
                reorder: true,
                keepOneSelected: true,
                iconBtn: "tune",
                removeDMOnReset: this.isSearchPage,
                noDataModel: this.hideDataModelSettings,
                expandCatalogues: false
            };
        },
        exportInstancesColumns() {
            const columnsToBeDisplayed = JSON.parse(JSON.stringify(this.instancesColumns)).filter(elem => elem.name !== "action");
            columnsToBeDisplayed.forEach(elem => {
                if (elem.name === "instanceName" || elem.name === "status") {
                    elem.required = false;
                } else if (elem.name === "instanceID") {
                    elem.required = true;
                }
            });
            return columnsToBeDisplayed;
        },
        getExportSettInstancesProps() {
            return {
                atId: "reports-instances",
                title: this.$t("dataTable.exportInstancesTitle"),
                columns: this.exportInstancesColumns,
                dataModelMode: "ii",
                forceModelUpdate: true,
                iconBtn: "save_alt",
                hideDefaultBtn: true,
                labelConfirmButton: this.$t("dataTable.btnExport"),
                infoTooltip: this.$t("exportReports.exportInstanceInfo"),
                reorder: true,
                noDataModel: this.hideDataModelSettings,
                expandCatalogues: false
            };
        },
        getTableInstancesProps() {
            return {
                atId: "reports-instances",
                columns: this.instancesColumns,
                tableData: this.instancesData,
                totalPages: this.instancesTotalPages,
                totalItems: this.counterInstances,
                resetCurrentPage: this.resetCurrentPageInstances,
                sortPreferences: this.getSortInstancesPreferences,
                loading: this.loadingInstances,
                removeTableBorder: true,
                hideHeaderOnNoData: !this.hasExternalData,
                loadingStyle: INSTANCES_LOADING_STYLE,
                reduseFromTableHeight: this.getReduceHeight,
                hideBottom: !this.isFullScreen,
                styledTable: true,
                rowColorSeparator: true
            };
        },
        getSortInstancesPreferences() {
            return this.pageType ? this.instancesInitialSort : this.customInstancesSort;
        },
        isBulkMode() {
            return !!(this.actionBulk && this.actionBulk[0]);
        },
        isBulkActionReassign() {
            return (this.isBulkMode && this.actionBulk[0].value === "bulkReassign");
        },
        isBulkActionReassignExternal() {
            return (this.isBulkMode && this.actionBulk[0].value === "bulkReassignExternal");
        },
        isBulkActionUnclaim() {
            return (this.isBulkMode && this.actionBulk[0].value === "bulkUnclaim");
        },
        isExpandStatus() {
            return this.statusExpandCollapse === "expand";
        },
        setFullScreenIcon() {
            return this.isFullScreen ? "fullscreen_exit" : "fullscreen";
        },
        getTooltipContent() {
            return this.$t(`liveView.tasksInstances.${this.isExpandStatus ? "collapse" : "expand"}`);
        },
        getTooltipFullscreen() {
            return this.$t(`liveView.tasksInstances.${this.isFullScreen ? "tooltipDiagramView" : "tooltipFullScreen"}`);
        },
        isOwner() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("owner");
        },
        hasWriteRT() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("permissionsData")
            && this.$route.params.permissions.permissionsData.hasOwnProperty("RT") && this.$route.params.permissions.permissionsData.RT === "w";
        },
        hasWriteUC() {
            return this.$route.params.permissions && this.$route.params.permissions.hasOwnProperty("permissionsData")
            && this.$route.params.permissions.permissionsData.hasOwnProperty("UC") && this.$route.params.permissions.permissionsData.UC === "w";
        },
        isInstancesTab() {
            return this.selectedTab === "tab-instances";
        },
        setBulkTitle() {
            return this.isBulkMode ? this.$t(`liveView.tasksInstances.${this.actionBulk[0].value}`) : "";
        },
        setSelectAllTitle() {
            return this.selectAllTitle();
        }
    },
    watch: {
        activitiesDataPerspective: {
            handler(value) {
                if (value && value.length) {
                    this.setLocalBulkOps(value);
                }
            }
        },
        resetFilters: {
            handler(newValue) {
                this.noTriggerAction = newValue;
            },
            immediate: true
        },
        "tasksInstExData.tabs": {
            handler(newValue) {
                if (newValue) {
                    this.tabsConfig = newValue.filter(elem => elem.visible);
                    const [firstTab] = this.tabsConfig;
                    this.selectedTab = firstTab ? firstTab.value : "";
                }
            },
            immediate: true,
            deep: true
        },
        "tasksInstExData.tasksData": {
            handler(newValue) {
                if (this.hasExternalData && newValue && newValue.data) {
                    this.setTabExtraData(newValue, "tasks");
                }
            },
            immediate: true,
            deep: true
        },
        "tasksInstExData.instanceData": {
            handler(newValue) {
                if (this.hasExternalData && newValue && newValue.data) {
                    this.setTabExtraData(newValue, "instances");
                }
            },
            immediate: true,
            deep: true
        },
        "tasksInstExData.tasksColumns": {
            handler(newValue) {
                if (this.isSearchPage) {
                    this.tasksFirstLoad = true;
                    this.instancesFirstLoad = true;
                    this.tasksInitialSort = null;
                    this.instancesInitialSort = null;
                }
                if (!this.tasksInitialSort || !(this.tasksInitialSort.columnsWithTypes && this.tasksInitialSort.columnsWithTypes.length)) {
                    this.setDefaultExtraCols(newValue, "tasksColumns");
                }
            },
            immediate: true,
            deep: true
        },
        "tasksInstExData.instancesColumns": {
            handler(newValue) {
                if (this.isSearchPage) {
                    this.tasksFirstLoad = true;
                    this.instancesFirstLoad = true;
                    this.tasksInitialSort = null;
                    this.instancesInitialSort = null;
                }
                if (!this.instancesInitialSort || !(this.instancesInitialSort.columnsWithTypes && this.instancesInitialSort.columnsWithTypes.length)) {
                    this.setDefaultExtraCols(newValue, "instancesColumns");
                }
            },
            immediate: true,
            deep: true
        },
        "tasksInstExData.allowSorting": {
            handler(newValue) {
                if (this.hasExternalData && this.pageType !== "searchPerspectives") {
                    this.setCustomPreferences(newValue);
                }
            },
            immediate: true
        },
        selectedPluginUuid: {
            handler(newValue) {
                if (!this._inactive) {
                    if (newValue) {
                        this.executeOnSelectPlugin();
                    } else if (!this.triggerOnSearch) {
                        this.hideOptions = false;
                        this.payloadTasks.taskAndInstanceFilterModel.taskStatus = [];
                        this.currentSelectedAnchoredData = {};
                        if (this.selectedTab === "tab-instances") {
                            this.resetCurrentPageInstances = true;
                            this.instancesGetTabData();
                        } else {
                            this.resetCurrentPageTasks = true;
                            this.tasksGetTabData();
                        }
                        const { activityIds, taskStatus, ...otherQueryParams } = this.$route.query;
                        if (!this.isStatistics && (activityIds || taskStatus)) {
                            this.$router.replace({ query: otherQueryParams });
                        }
                    }
                }
            }
        },
        selectedProcess: {
            handler() {
                if (this.pageType === "reports") {
                    this.selectedTab = "tab-tasks";
                    this.instancesData = [];
                    this.checkForSortPreferences("tasks", this.tasksPageName);
                }
            }
        },
        selectedAchoredPlugin: {
            handler(newValue) {
                const { anchorUuid } = this.currentSelectedAnchoredData;
                const { anchorPosition } = this.currentSelectedAnchoredData;
                const checkValue = (!newValue.anchorUuid && anchorUuid && this.selectedPluginUuid) || (!anchorUuid && newValue.anchorUuid);

                if (checkValue || (anchorUuid && newValue.anchorUuid && (anchorUuid === newValue.anchorUuid)
                        && (anchorPosition !== newValue.anchorPosition))) {
                    this.hasStatusPreferences = false;
                    this.executeOnSelectPlugin();
                }
                this.currentSelectedAnchoredData = newValue;
            },
            deep: true
        },
        activitiesData: {
            handler(value) {
                if (value && value.length) {
                    this.setLocalBulkOps(value);
                }
            },
            immediate: true
        },
        propFullScreen: {
            handler(newValue) {
                this.isFullScreen = newValue;
            },
            immediate: true
        },
        propExpand: {
            handler(newValue) {
                this.statusExpandCollapse = newValue;
            },
            immediate: true
        }
    },
    created() {
        if (!this.hasExternalData) {
            this.tabsConfig = TABS_CONFIG.map(elem => elem);
        }
        this.$root.$on("clearFilters", (data) => {
            this.clearFilters = data;
        });
    },
    mounted() {
        eventBus.$on("refreshReportsTasks", () => {
            if (!this._inactive) {
                this.refreshData();
            }
        });
        eventBus.$on("perspectiveLoaded", () => {
            this.hasStatusPreferences = true;
        });

        eventBus.$on("selectStatusFromDDL", () => {
            this.hasStatusPreferences = true;
        });

        eventBus.$on("resetLoadFilter", () => {
            this.noTriggerAction = false;
        });
        eventBus.$on("resetPerspectiveCurrentPage", () => {
            if (this.selectedTab === "tab-tasks") {
                this.tasksPagination.page = 0;
            } else {
                this.instancesPagination.page = 0;
            }
        });

        if (this.$route.query.filterId) {
            this.hasStatusPreferences = true;
        } else if (this.getCurrentSelectedProcess && this.getCurrentSelectedProcess.id) {
            if (this.tasksInstExData && this.tasksInstExData.instanceData) {
                this.instancesGetTabData();
            }
            this.tasksGetTabData();
        }
        this.preferencesError = this.isSearchPage;

        this.$root.$on("getItemsReports", (data) => {
            if (!this._inactive) {
                this.searchAction = true;
                this.triggerOnSearch = true;
                this.isOnSwitch = false;
                this.executedOnSearch = true;
                this.callOnSearch = true;
                this.payloadTasks.page = 0;
                this.currentSelectedAnchoredData = {};
                if (data.hasOwnProperty("searchTerm")) {
                    this.payloadTasks.searchTerm = data.searchTerm;
                }
                this.payloadTasks.taskAndInstanceFilterModel = data.taskAndInstanceFilterModel;
                const [firstSelected] = this.payloadTasks.taskAndInstanceFilterModel.activityIds || [];
                if ((!this.isSearchPage || this.tabsConfig.length !== 1) && firstSelected && this.activitiesData) {
                    const generalEndActiv = this.activitiesData.find(elem => elem.activityId === firstSelected);
                    if (generalEndActiv && generalEndActiv.activityType === "GENERAL_END_PLUGIN") {
                        this.selectedTab = "tab-instances";
                    } else {
                        this.selectedTab = "tab-tasks";
                    }
                }

                this.$nextTick(() => {
                    if (this.selectedTab === "tab-tasks") {
                        this.resetCurrentPageTasks = !this.hasInitialPage;
                        this.tasksGetTabData(null, true, true);
                    } else {
                        this.resetCurrentPageInstances = !this.hasInitialPage;
                        this.instancesGetTabData(null, true, true);
                    }
                    if (this.hasInitialPage) {
                        this.hasInitialPage = false;
                    }

                    if (this.pageType !== "searchPerspectives" && !this.isFullScreen && !this.isExpandStatus) {
                        this.actionExpandCollapse();
                    }
                });
            }
        });
    },
    activated() {
        if (this.selectedProcess && this.isSearchPage) {
            const checkInitialPage = (type) => (this[`${type}Pagination`].size ? !!this[`${type}Pagination`].page : !!this.payloadTasks.page);
            this.tasksInitialSort = null;
            this.instancesInitialSort = null;
            this.tasksFirstLoad = true;
            this.instancesFirstLoad = true;
            this.hasInitialPage = checkInitialPage(this.selectedTab === "tab-tasks" ? "tasks" : "instances");
        }
    },
    deactivated() {
        if (this.payloadTasks) {
            this.payloadTasks.searchTerm = "";
        }
    },
    destroy() {
        this.$root.$off("clearFilters");
    },
    methods: {
        ...mapActions("reports",
            ["getAllTasks", "getAllInstances",
                "getGuiItemDetails", "getTasksTotalCounter",
                "getInstancesTotalCounter", "getTaskInformation",
                "getItemsOnBulk", "saveReportsSortPreferences",
                "getReportsSortPreferences", "getReportsTaskAssignees",
                "exportReportsTasksInstances", "cancelReportsExport"]),
        getDefaultVisibleCols(defaultType) {
            const defaultDataList = defaultType === "tasks" ? TABLE_TASKS_CONFIG : TABLE_INSTANCES_CONFIG;
            const newData = this.tasksInstExData[`${defaultType}Columns`].filter(({ visible, value }) => (visible && value !== "more"));
            const data = [];
            newData.forEach(elem => {
                if (elem.type) {
                    const { type, value, dataType, label, visible } = elem;
                    const isDataModel = type === "DATA_MODEL";
                    const fieldValue = value.replace((isDataModel ? "m_" : "s_"), "");
                    const newColumn = {
                        type: isDataModel ? "MOD" : "VAR",
                        dataModelType: true,
                        dataType,
                        typeFormatted: value,
                        align: dataType === "string" ? "left" : "right",
                        field: fieldValue,
                        name: value,
                        label,
                        sortable: false,
                        visible,
                        style: "width:1%"
                    };
                    data.push(newColumn);
                } else {
                    const colsDetails = defaultDataList.find(({ name }) => name === elem.value);
                    if (colsDetails) {
                        data.push({ ...colsDetails, visible: true });
                    }
                }
            });
            return data;
        },
        setLocalBulkOps(value) {
            const checkExternal = value.find(elem => elem.activityType === "EXTERNAL_PLUGIN");
            if (!checkExternal) {
                this.localBulkActions = this.moreBulkOptions.filter(elem => elem.value !== "bulkReassignExternal");
            } else {
                const activitiesWithoutEnd = value.filter(elem => elem.activityType !== "GENERAL_END_PLUGIN");
                const externalActivities = activitiesWithoutEnd.filter(elem => elem.activityType === "EXTERNAL_PLUGIN");
                if (activitiesWithoutEnd.length === externalActivities.length) {
                    this.localBulkActions = this.moreBulkOptions.filter(elem => elem.value !== "bulkReassign");
                } else {
                    const exposeApiActivities = activitiesWithoutEnd.filter(elem => elem.activityType === "EXPOSE_API_PLUGIN");
                    if (activitiesWithoutEnd.length === exposeApiActivities.length) {
                        this.localBulkActions = this.moreBulkOptions.filter(elem => elem.value === "bulkUnclaim");
                    } else {
                        this.localBulkActions = this.moreBulkOptions;
                    }
                }
            }
        },
        refreshData() {
            if (this.isInstancesTab) {
                this.instancesGetTabData();
            } else {
                this.tasksGetTabData();
            }
        },
        setDefaultExtraCols(newValue, type) {
            if (this.hasExternalData && newValue) {
                const getDefaultData = type === "tasksColumns" ? TABLE_TASKS_CONFIG : TABLE_INSTANCES_CONFIG;
                this[type] = this.setTasksDefaultColumns(getDefaultData);
                const getVisibleCols = () => newValue.filter(elem => (elem.visible));
                this[type] = this.setNewOrderColumnsOnLoad(this.isSearchPage ? getVisibleCols() : newValue, type);
            }
        },
        setTasksDefaultColumns(data) {
            return data.map(item => ({ ...item }));
        },
        columnsOpenData(data) {
            eventBus.$emit("disableEventEnter", data);
        },
        switchTab(isTask, data) {
            if (isTask) {
                this.payloadTasks.searchTerm = data.processInstanceId;
                this.selectedTab = "tab-instances";
            } else {
                this.payloadTasks.searchTerm = data.instanceId;
                this.selectedTab = "tab-tasks";
            }
            this.selectedTabChanged(this.selectedTab);
            this.isOnSwitch = true;
            eventBus.$emit("searchTasksAndInstances", this.payloadTasks.searchTerm);
            const { query } = this.$route;
            this.$router.replace({ query: { ...query, search: this.payloadTasks.searchTerm } });
        },
        selectAllTitle() {
            let labelText = "";
            if (this.counterTasks > this.payloadTasks.size) {
                if (this.selectAllTasks && (this.counterTasks !== this.tasksSelectedList.length)) {
                    this.isSelectedAll = true;
                    labelText = this.$t("liveView.tasksInstances.clearAll");
                } else {
                    this.isSelectedAll = (this.selectAllTasks || (this.counterTasks === this.tasksSelectedList.length));
                    labelText = (this.selectAllTasks
                        || (this.counterTasks === this.tasksSelectedList.length) ? this.$t("liveView.tasksInstances.clearAll")
                        : this.$t("liveView.tasksInstances.selectAll", { counter: this.counterTasks }));
                }
            } else if (this.selectAllTasks && (this.counterTasks !== this.tasksSelectedList.length)) {
                this.isSelectedAll = false;
                labelText = this.$t("liveView.tasksInstances.selectAll", { counter: this.counterTasks });
            } else {
                this.isSelectedAll = (this.selectAllTasks || (this.counterTasks === this.tasksSelectedList.length));
                labelText = (this.selectAllTasks
                    || (this.counterTasks === this.tasksSelectedList.length) ? this.$t("liveView.tasksInstances.clearAll")
                    : this.$t("liveView.tasksInstances.selectAll", { counter: this.counterTasks }));
            }
            return labelText;
        },
        getQueryForRoute(isTasks) {
            const { searchTerm, taskAndInstanceFilterModel } = this.payloadTasks;
            const getDataModel = (v) => (v.map(item => encodeURIComponent(JSON.stringify(item))));
            const getDataForQuery = () => {
                const newQuery = {};
                Object.entries(taskAndInstanceFilterModel).forEach(([key, value]) => {
                    if (!["applicationId", "processDefinitionId"].includes(key) && value && value.length) {
                        newQuery[key] = value.toString();
                    }
                });
                return newQuery;
            };
            let activityIds;
            if (isTasks) {
                if (this.selectedPluginUuid) {
                    activityIds = this.selectedPluginUuid;
                } else if (this.isSearchPage && this.tasksInstExData && this.tasksInstExData.perspectiveActivity) {
                    activityIds = this.tasksInstExData.perspectiveActivity;
                }
            } else {
                activityIds = this.selectedPluginUuid || "";
            }

            const { dataModelFields } = taskAndInstanceFilterModel;
            const query = { ...(searchTerm ? { search: searchTerm } : {}),
                ...getDataForQuery(),
                ...(dataModelFields?.length ? { dataModelFields: getDataModel(dataModelFields) } : {}),
                ...(activityIds ? { activityIds } : {}) };

            this.$router.replace({ query });
        },
        executeOnSelectPlugin() {
            if (!this.hasStatusPreferences) {
                this.payloadTasks.taskAndInstanceFilterModel.taskStatus = this.setTaskStatus();
            }
            if (!this.isExpandStatus && !this.isFullScreen) {
                this.actionExpandCollapse();
            }
            if ((this.isSearchPage && this.tabsConfig.length === 1 && this.tabsConfig[0].value === "tab-instances")
            || (this.selectedPluginConfigData.pluginType === "GENERAL_END_PLUGIN" && this.tabsConfig.length === 2 && !this.isStatistics)) {
                if (this.instancesInitialSort) {
                    const allowSorting = this.isSearchPage ? this.tasksInstExData.allowSorting : true;
                    this.instancesInitialSort = {
                        sortBy: allowSorting ? "completionDate" : "",
                        descending: true
                    };
                }
                if (this.selectedTab !== "tab-instances") {
                    this.selectedTab = "tab-instances";
                }

                this.resetCurrentPageInstances = true;
                this.instancesGetTabData(null, true);
                this.getQueryForRoute();
            } else if (!this.isStatistics) {
                this.selectedTab = "tab-tasks";
                if (this.executedOnSearch) {
                    this.executedOnSearch = false;
                } else {
                    this.resetCurrentPageTasks = true;
                    this.tasksGetTabData(null, true, true);
                    this.getQueryForRoute(true);
                }
            }
            this.hideOptions = ["EXPOSE_API_PLUGIN", "BLOCKCHAIN_EVENT_PLUGIN"].includes(this.selectedPluginConfigData.pluginType);
        },
        setTaskStatus() {
            const status = this.selectedAchoredPlugin.anchorPosition; let
                returnStatus = [];
            if (status) {
                returnStatus = [this.taskStatuses[status]];
            }
            return returnStatus;
        },
        getTaskAssignees(data) {
            this.getReportsTaskAssignees(data.row.taskId).then(
                response => {
                    const responseData = { users: response.users || [], groups: response.groups || [] };
                    const remainingAssignees = (responseData.users.length > 1) || (responseData.groups.length > 1)
                        || (responseData.users.length === 1 && responseData.groups.length === 1);

                    this.tasksData[data.rowIndex].assignees = { ...responseData, remainingAssignees };
                    this.tasksData = [...this.tasksData];
                }
            );
        },
        exportTasksInstances(columns, type) {
            const columnsToSend = columns.filter(elem => elem.visible === true || elem.required === true);
            const mappedColumns = columnsToSend.map(elem => elem.name);
            this.exportPayload.excelDataModelFields = mappedColumns.map(elem => {
                let column = elem;
                if (EXPORT_MAPPINGS[elem]) {
                    if (type === "instance" && ["status", "creationDate", "endActivityName"].includes(elem)) {
                        const dataSet = {
                            status: "s_ProcessInstance.status",
                            creationDate: "s_ProcessInstance.startDateTime",
                            endActivityName: "s_ProcessInstance.endActivityName"
                        };
                        column = dataSet[elem];
                    } else {
                        column = EXPORT_MAPPINGS[elem];
                    }
                }
                return column;
            });
            const localdate = new Date();
            const findTimezone = localdate.toString().split("GMT")[1];
            const localTimezone = findTimezone.substring(0, 5);
            const timeZoneToSend = [localTimezone.slice(0, 3), ":", localTimezone.slice(3)].join("");

            this.exportPayload.searchModel = this.payloadTasks;
            this.exportPayload.processDefinitionId = this.getCurrentApplicationId;
            this.exportPayload.isTask = (type === "task");
            this.exportPayload.timezone = timeZoneToSend;

            this.exportReportsTasksInstances({ pageType: this.pageType, payload: this.exportPayload }).then(
                () => {
                    this.$toast.showNotify({
                        type: "info",
                        message: this.$t("dataTable.exportMessage"),
                        buttonLabel: this.$t("generic.cancel"),
                        actionEvent: this.cancelExport
                    });
                }
            );
        },
        cancelExport() {
            this.cancelReportsExport({ typeTask: this.exportPayload.isTask, currentProcessId: this.selectedProcess.id }).then(
                () => {
                    this.$toast.showNotify({
                        type: "success",
                        message: this.$t("liveView.tasksInstances.cancelRequest")
                    });
                }
            );
        },
        openBulkActions() {
            const activityId = this.payloadTasks.taskAndInstanceFilterModel.activityIds; let
                activityType = "";
            if (activityId && activityId.length) {
                const activity = this.activitiesData.find(elem => elem.activityId === activityId[0]);
                activityType = activity.activityType;
                if (activityType === "TASK_PLUGIN" || activityType === "APPROVAL_PLUGIN") {
                    this.actionsBulkOptions = this.moreBulkOptions.filter(elem => elem.value !== "bulkReassignExternal");
                } else if (activityType === "EXTERNAL_PLUGIN") {
                    this.actionsBulkOptions = this.moreBulkOptions.filter(elem => elem.value !== "bulkReassign");
                } else {
                    this.actionsBulkOptions = this.localBulkActions;
                }
            } else {
                this.actionsBulkOptions = this.localBulkActions;
            }
        },
        setMoreActions(data) {
            let response;
            if ((this.isOwner || this.hasWriteRT || this.hasWriteUC) && data.taskType !== "EXPOSE_API_PLUGIN") {
                response = (data.canUnclaim || data.canReassign || data.canEscalate);
            }
            return response;
        },
        saveSortPreferences: debounce(function saveSortPreferences(sortAndColumnSettings, interfaceName, refreshData, noInitialSort) {
            const payload = {
                interfaceName,
                contentData: { sortAndColumnSettings },
                perspectiveId: this.hasExternalData ? this.perspectiveId : "",
                appId: this.getCurrentApplicationId
            };
            this.saveReportsSortPreferences({ processId: this.selectedProcess.id, data: payload }).then(
                () => {
                    this.preferencesError = false;

                    if (refreshData) {
                        if (this.selectedTab === "tab-tasks") {
                            if (this.isSearchPage && noInitialSort) {
                                this.tasksInitialSort = JSON.parse(JSON.stringify(this.customTasksSort));
                            }
                            this.tasksGetTabData(refreshData, false);
                        } else {
                            if (this.isSearchPage && noInitialSort) {
                                this.instancesInitialSort = JSON.parse(JSON.stringify(this.customInstancesSort));
                            }
                            this.instancesGetTabData(refreshData, false);
                        }
                    }
                }
            ).catch(({ response = {} }) => {
                const { data: { status } = {} } = response;
                if (status === 500) {
                    this.$toast.showNotify({
                        type: "error",
                        code: "filter-loadFail",
                        message: this.$t("searchPerspectives.sortSettingsError")
                    });
                } else if (status === 409) {
                    this.$toast.showNotify({
                        type: "error",
                        code: "filter-loadFail",
                        message: this.$t("searchPerspectives.loadFilterError")
                    });
                }
                this.preferencesError = false;
            });
        }, 600),
        selectTabOnClick() {
            if (!this.isFullScreen && this.statusExpandCollapse === "collapse") {
                this.actionExpandCollapse();
            }
            if (this.isOnSwitch) {
                this.isOnSwitch = false;
                this.$toast.showNotify({
                    type: "warning",
                    message: this.$t("liveView.tasksInstances.switchTabWarning")
                });
            }
        },
        activateBulkActions() {
            this.payloadTasks.bulkSpecifications = {
                bulkReassign: this.isBulkActionReassign,
                bulkUnclaim: this.isBulkActionUnclaim,
                bulkReassignExternal: this.isBulkActionReassignExternal
            };
            this.tasksSelection = "multiple";
            this.resetCurrentPageTasks = true;
            this.tasksColumns = this.tasksColumns.filter(col => !this.colsToRemove.includes(col.name));
            this.tasksGetTabData(null, true);
        },
        setActionBulk(actionType) {
            if (actionType === "cancel") {
                this.actionBulk = [];
                this.tasksSelection = "none";
                this.tasksSelectedList = [];
                this.selectAllTasks = false;
                this.showAllItemsSelected = false;
                this.resetCurrentPageTasks = true;
                this.tasksColumns = [...this.tasksColumns, ...this.tableFixedCols];
                this.tasksGetTabData(null, true);
            } else {
                this.payloadTasks.bulkSpecifications = {
                    bulkReassign: this.isBulkActionReassign,
                    bulkUnclaim: this.isBulkActionUnclaim,
                    bulkReassignExternal: this.isBulkActionReassignExternal
                };
                if (this.isSelectedAll) {
                    this.getItemsOnBulk(this.payloadTasks).then(
                        data => {
                            this.tasksSelectedIdsList = data;
                            this.bulkAllModal = true;
                        }
                    );
                } else if (this.selectAllTasks && this.counterTasks > this.payloadTasks.size) {
                    const allTasksListIds = this.tasksData.map(elem => elem.id);
                    const allSelectedTasksIds = this.tasksSelectedList.map(elem => elem.id);
                    const blackIdsList = allTasksListIds.filter(elem => !allSelectedTasksIds.includes(elem));
                    this.getItemsOnBulk(this.payloadTasks).then(
                        data => {
                            this.tasksSelectedIdsList = data.filter(elem => !blackIdsList.includes(elem));
                            this.bulkAllModal = true;
                        }
                    );
                } else {
                    this.tasksSelectedIdsList = this.tasksSelectedList.map(elem => elem.taskId);
                    this.bulkAllModal = true;
                }
            }
            this.hideTasksPagination = false;
        },
        changePagination(data) {
            const sortDirection = data.descending ? "DESC" : "ASC";
            let dataToSave;
            let interfaceName = "";
            const initialPage = this.payloadTasks.page;
            const initialSize = this.payloadTasks.size;
            this.payloadTasks.page = data.page - 1;
            this.payloadTasks.size = data.rowsPerPage;
            this.payloadTasks.sortDirection = data.sortBy ? sortDirection : null;
            this.payloadTasks.sortField = data.sortBy;
            this.preferencesError = this.isSearchPage;
            if (this.selectedTab === "tab-tasks") {
                const checkInitialParams = () => {
                    const { page, size } = this.payloadTasks;
                    return (initialPage === page && initialSize === size);
                };
                const checkTrigger = () => (this.isSearchPage ? (this.tasksFirstLoad && checkInitialParams()) : this.tasksFirstLoad);
                if (checkTrigger()) {
                    this.tasksFirstLoad = false;
                } else {
                    this.tasksPagination = { ...this.payloadTasks };
                    this.tasksGetTabData();
                    interfaceName = this.tasksPageName;
                    dataToSave = this.changeDataSort("tasks");
                    this.tasksFirstLoad = false;
                }
            } else if (this.instancesFirstLoad) {
                this.instancesFirstLoad = false;
            } else {
                this.instancesPagination = { ...this.payloadTasks };
                this.instancesGetTabData();
                interfaceName = this.instancesPageName;
                dataToSave = this.changeDataSort("instances");
            }
            if (dataToSave) {
                this.saveSortPreferences(dataToSave, interfaceName);
            }
        },
        changeDataSort(type) {
            const checkSave = ((this[`${type}SortPreferences`].sortType !== this.payloadTasks.sortDirection)
                || (this[`${type}SortPreferences`].sortBy !== this.payloadTasks.sortField));
            if (checkSave) {
                this[`${type}SortPreferences`].sortType = this.payloadTasks.sortDirection;
                this[`${type}SortPreferences`].sortBy = this.payloadTasks.sortField;
            }
            return checkSave ? this[`${type}SortPreferences`] : null;
        },
        getSelectedRows(data) {
            this.tasksSelectedList = data;
        },
        bulkSelectAllItems() {
            if (this.isSelectedAll) {
                this.selectAllTasks = false;
                this.hideTasksPagination = false;
                this.tasksSelectedList = [];
                this.showAllItemsSelected = false;
            } else {
                this.selectAllTasks = true;
                this.hideTasksPagination = true;
                this.tasksSelectedList = this.tasksData;
                this.showAllItemsSelected = true;
            }
        },
        orderColumnsChanged(newColumns, tasksTab) {
            const onlyDataModelCols = [];
            let newOrderColumns = [];
            let dataNewColumns = [...newColumns];
            if (tasksTab) {
                dataNewColumns = [...dataNewColumns, this.tableFixedCols[1]];
            }
            newOrderColumns = dataNewColumns.map(elem => {
                const setType = elem.type === "MOD" ? "DATA_MODEL" : "SYSTEM_VARIABLE";
                if (elem.dataModelType) {
                    onlyDataModelCols.push(elem.name);
                }
                return {
                    column: elem.dataModelType ? elem.typeFormatted : elem.name,
                    columnName: elem.label,
                    dataType: elem.dataType || null,
                    type: elem.dataModelType ? setType : null,
                    visible: !!(elem.visible || elem.required)
                };
            });
            this.preferencesError = this.isSearchPage;
            const getNewPreferencesCols = (v) => {
                if (this.isSearchPage && !this.tasksInstExData.allowUseSettingsModel) {
                    const dmList = this.tasksInstExData[v].filter(taskElem => taskElem.type);
                    const newColsDM = newOrderColumns.filter(col => col.type).map(mapCol => mapCol.column);
                    const extraCols = [];
                    if (dmList.length) {
                        dmList.forEach(e => {
                            if (!newColsDM.includes(e.value) && e.visible) {
                                extraCols.push({
                                    column: e.value,
                                    columnName: e.label,
                                    dataType: e.dataType || null,
                                    type: e.type || null,
                                    visible: !!(e.visible || e.required)
                                });
                            }
                        });

                        if (tasksTab) {
                            const [last, ...rest] = newOrderColumns.reverse();
                            newOrderColumns = [...rest.reverse(), ...extraCols, last];
                        } else {
                            newOrderColumns = [...newOrderColumns, ...extraCols];
                        }
                    }
                }
            };
            if (tasksTab) {
                getNewPreferencesCols("tasksColumns");
                const initialDataModelCols = this.tasksColumns.filter(elem => elem.dataModelType).map(item => item.name);
                this.tasksSortPreferences.columns = [];
                this.tasksSortPreferences.columnsWithTypes = newOrderColumns;
                if (this.checkToRefreshData(initialDataModelCols, onlyDataModelCols)) {
                    this.saveSortPreferences(this.tasksSortPreferences, this.tasksPageName, dataNewColumns);
                } else {
                    this.tasksGetTabData(dataNewColumns);
                    this.saveSortPreferences(this.tasksSortPreferences, this.tasksPageName);
                }
            } else {
                getNewPreferencesCols("instancesColumns");
                const initialDataModelCols = this.instancesColumns.filter(elem => elem.dataModelType).map(item => item.name);
                this.instancesSortPreferences.columns = [];
                this.instancesSortPreferences.columnsWithTypes = newOrderColumns;

                if (this.checkToRefreshData(initialDataModelCols, onlyDataModelCols)) {
                    this.saveSortPreferences(this.instancesSortPreferences, this.instancesPageName, dataNewColumns);
                } else {
                    this.instancesGetTabData(dataNewColumns);
                    this.saveSortPreferences(this.instancesSortPreferences, this.instancesPageName);
                }
            }
        },
        checkToRefreshData(initialData, updatedData) {
            let refreshData = false;
            if (updatedData.length || initialData.length) {
                if (updatedData.length === initialData.length) {
                    for (let i = 0; i < updatedData.length; i++) {
                        if (!initialData.includes(updatedData[i])) {
                            refreshData = true;
                            break;
                        }
                    }
                } else {
                    refreshData = true;
                }
            }

            return refreshData;
        },
        selectedTabChanged(tabType) {
            if (tabType === "tab-instances") {
                if (this.isBulkMode) {
                    this.tasksColumns = [...this.tasksColumns, ...this.tableFixedCols];
                }
                this.actionBulk = [];
                this.tasksSelection = "none";
                this.tasksSelectedList = [];
                this.selectAllTasks = false;
                this.showAllItemsSelected = false;
                this.executedOnSearch = true;
                this.checkForSortPreferences("instances", this.instancesPageName);
            } else {
                this.tasksGetTabData();
            }
        },
        viewTaskDetails(data) {
            if (this.isInstancesTab) {
                const { endActivityId, instanceId } = data;
                const viewObject = {
                    endActivityId,
                    instanceId,
                    perspectiveId: this.perspectiveId,
                    appId: this.getCurrentApplicationId,
                    hasCustomInterface: this.customInterface
                };
                this.getGuiItemDetails(viewObject).then(
                    response => {
                        if (response) {
                            const dataProps = {
                                activityId: data.endActivityId || this.selectedPluginConfigData.uuid,
                                guiId: response.guiDetails.id,
                                processDefinitionId: this.getCurrentSelectedProcess.id,
                                processInstanceId: data.instanceId,
                                canUnclaim: false,
                                canReassign: false,
                                taskId: response.taskId,
                                taskExternalReports: false,
                                externalPhone: false,
                                instanceTab: true,
                                perspectiveId: this.perspectiveId,
                                appId: this.getCurrentApplicationId
                            };
                            this.redirectToTaskDetails(dataProps);
                        }
                    },
                    (error) => {
                        if (error.response.data && error.response.data.status === 409) {
                            this.$toast.showNotify({
                                type: "error",
                                code: "filter-loadFail",
                                message: this.$t("searchPerspectives.loadFilterError")
                            });
                        } else {
                            this.$toast.showNotify({
                                message: this.$t("liveView.tasksInstances.noInterfaceError"),
                                type: "error"
                            });
                        }
                    }
                );
            } else {
                const dataProps = {
                    activityId: data.activityId || this.selectedPluginConfigData.uuid,
                    guiId: data.guiId,
                    processDefinitionId: this.getCurrentSelectedProcess.id,
                    processInstanceId: data.processInstanceId,
                    canUnclaim: (this.isOwner || this.hasWriteUC) ? data.canUnclaim : false,
                    canReassign: (this.isOwner || this.hasWriteRT) ? data.canReassign : false,
                    taskId: data.taskId,
                    instanceTab: false,
                    taskExternalReports: data.taskType === "EXTERNAL_PLUGIN",
                    externalPhone: false,
                    perspectiveId: this.perspectiveId,
                    appId: this.getCurrentApplicationId
                };
                this.redirectToTaskDetails(dataProps, data.taskType === "EXPOSE_API_PLUGIN");
            }
        },
        redirectToTaskDetails(dataProps, isExposeApi) {
            const dataToSend = { ...dataProps };
            if (isExposeApi) return;
            this.$store.commit("main/setTaskId", dataProps.taskId);
            if (!dataProps.instanceTab) {
                const taskPayload = {
                    perspectiveId: dataProps.perspectiveId,
                    appId: dataProps.appId
                };
                this.getTaskInformation(taskPayload);
            }

            const { appId, taskId } = dataToSend;
            const taskType = dataProps.instanceTab ? "instances" : "tasks";
            const page = `/applications/${appId}/${this.isSearchPage ? `dataViews/${dataProps.perspectiveId}` : "analytics"}/${taskType}/${taskId}`;
            if (taskId) {
                window.open(`/${PLATFORM_BASE_PATH}${page}`);
            }
        },
        moreActionsTrigger(action, dataItem) {
            this.moreActionModel = {
                action,
                taskId: dataItem.taskId,
                taskType: dataItem.taskType,
                targetType: dataItem.targetType
            };
            this.openUnclaimReassign = dataItem.taskId;
        },
        modalClosed() {
            this.openUnclaimReassign = null;
            this.moreActionModel = null;
        },
        modalBulkClosed() {
            this.bulkAllModal = false;
        },
        bulkActionSuccess() {
            this.tasksSelection = "none";
            this.moreActionModel = null;
            this.actionBulk = [];
            this.tasksSelectedList = [];
            this.tasksSelectedIdsList = [];
            this.selectAllTasks = false;
            this.showAllItemsSelected = false;
            this.tasksColumns = [...this.tasksColumns, ...this.tableFixedCols];
            this.tasksGetTabData();
        },
        actionExpandCollapse() {
            if (!this.isSearchPage || (!this.propFullScreen && this.propExpand)) {
                if (this.isExpandStatus) {
                    this.statusExpandCollapse = "collapse";
                } else {
                    this.statusExpandCollapse = "expand";
                }
                this.$emit("expandCollapse", this.statusExpandCollapse);
            }
        },
        setStatusFullscreen() {
            this.isFullScreen = !this.isFullScreen;
            if (!this.isFullScreen) {
                this.statusExpandCollapse = "expand";
            }
            this.$emit("fullscreenView", this.isFullScreen);
        },
        tasksGetTabData: debounce(function tasksGetTabData(refreshData, resetPage, fromSearchContainer) {
            if (this.pageType) {
                if (this.tasksInitialSort) {
                    this.loadingTasks = true;
                    this.payloadTasks.taskAndInstanceFilterModel.applicationId = this.getCurrentApplicationId;
                    this.payloadTasks.taskAndInstanceFilterModel.processDefinitionId = this.selectedProcess.id;
                    const hasActivity = this.payloadTasks.taskAndInstanceFilterModel.activityIds
                        && this.payloadTasks.taskAndInstanceFilterModel.activityIds.length;
                    if (!this.isBulkMode && this.payloadTasks.hasOwnProperty("bulkSpecifications")) {
                        delete this.payloadTasks.bulkSpecifications;
                    } else if (hasActivity && this.selectedPluginUuid !== this.payloadTasks.taskAndInstanceFilterModel.activityIds[0]
                        && this.payloadTasks.hasOwnProperty("bulkSpecifications")) {
                        delete this.payloadTasks.bulkSpecifications;
                        this.setActionBulk("cancel");
                    }

                    if (!this.executedOnSearch) {
                        const getActivityData = () => {
                            let activityData = [];
                            if (this.selectedPluginUuid) {
                                activityData = [this.selectedPluginUuid];
                            } else if (this.isSearchPage && this.tasksInstExData && this.tasksInstExData.perspectiveActivity) {
                                activityData = this.tasksInstExData.perspectiveActivity;
                            }
                            return activityData;
                        };
                        this.payloadTasks.taskAndInstanceFilterModel.activityIds = getActivityData();
                    }

                    if (this.payloadTasks.sortBy === "completionDate") {
                        this.payloadTasks.sortBy = this.tasksSortPreferences.sortBy;
                        this.payloadTasks.sortType = this.tasksSortPreferences.sortType;
                    }
                    if (this.tasksPagination.size) {
                        this.payloadTasks.size = this.tasksPagination.size;
                        if (resetPage) {
                            this.tasksPagination.page = 0;
                        }
                        this.payloadTasks.page = this.tasksPagination.page;
                    } else {
                        this.payloadTasks.size = 10;
                        this.payloadTasks.page = 0;
                    }
                    if (this.isSearchPage && this.tasksInstExData && this.tasksInstExData.perspectiveTasksStatus) {
                        this.payloadTasks.taskAndInstanceFilterModel.taskStatus = this.tasksInstExData.perspectiveTasksStatus;
                    }
                    const payload = JSON.parse(JSON.stringify(this.payloadTasks));
                    this.hasStatusPreferences = false;
                    if (this.noTriggerAction) {
                        this.noTriggerAction = false;
                        this.resetCurrentPageTasks = false;
                        this.stopLoading("loadingTasks");
                    } else {
                        const customPayload = { pageType: this.pageType, payload };
                        this.getAllTasks(customPayload).then(
                            data => {
                                if (data.totalCount === 0 && fromSearchContainer && !this.clearFilters) {
                                    this.searchAction = false;
                                }
                                this.preferencesError = false;
                                this.setDataTasksResponse(data);
                                this.resetCurrentPageTasks = false;
                                if (this.triggerOnSearch) {
                                    this.triggerOnSearch = false;
                                    this.executedOnSearch = false;
                                }
                                if (refreshData) {
                                    this.tasksColumns = refreshData;
                                }
                                this.stopLoading("loadingTasks");
                            }
                        )
                            .catch(({ response = {} }) => {
                                const { data: { status } = {} } = response;
                                if (status === 401) {
                                    this.$emit("checkPermission");
                                } else if (status === 409 && !this.preferencesError) {
                                    this.$toast.showNotify({
                                        type: "error",
                                        code: "filter-loadFail",
                                        message: this.$t("searchPerspectives.loadFilterError")
                                    });
                                }
                            });
                        const checkTabs = () => {
                            let noAccess;
                            if (this.isSearchPage) {
                                noAccess = this.tabsConfig.length === 1;
                            }
                            return !noAccess;
                        };

                        if (this.callOnSearch && checkTabs()) {
                            this.getInstancesTotalCounter(customPayload).then(
                                data => {
                                    this.preferencesError = false;
                                    this.counterInstances = data;
                                }
                            )
                                .catch(({ response = {} }) => {
                                    const { data: { status } = {} } = response;
                                    if (status === 401) {
                                        this.$emit("checkPermission");
                                    } else if (status === 409 && !this.preferencesError) {
                                        this.$toast.showNotify({
                                            type: "error",
                                            code: "filter-loadFail",
                                            message: this.$t("searchPerspectives.loadFilterError")
                                        });
                                    }
                                });
                        }
                    }
                } else {
                    this.checkForSortPreferences("tasks", this.tasksPageName);
                }
            }
        }, 0),
        stopLoading: debounce(function stopLoading(type) {
            this[type] = false;
        }, 300),
        setDataTasksResponse(data) {
            this.counterTasks = data.totalCount;
            this.tasksTotalPages = data.totalPages;
            this.tasksData = data.tasks.map(elem => {
                elem.taskInformationModel.targetType = elem.targetType;
                if (elem.dataModelFields && elem.dataModelFields.length) {
                    elem.taskInformationModel = { ...elem.taskInformationModel, ...this.extractDataModelInfo(elem.dataModelFields) };
                }

                if (elem.systemVariables && elem.systemVariables.length) {
                    elem.taskInformationModel = { ...elem.taskInformationModel, ...this.extractDataModelInfo(elem.systemVariables) };
                }

                return elem.taskInformationModel;
            });

            this.tasksData.forEach(elem => {
                elem.id = elem.taskId;
            });

            this.showUserActionsReassign = !!this.tasksData.find(element => element.canReassign);
            this.showUserActionsUnclaim = !!this.tasksData.find(element => element.canUnclaim);
        },
        extractDataModelInfo(data) {
            let newData = {};
            data.forEach(elem => {
                newData = { ...newData, ...elem };
            });
            return newData;
        },
        instancesGetTabData: debounce(function instancesGetTabData(refreshData, resetPage, fromSearchContainer) {
            if (this.pageType) {
                if (this.instancesInitialSort) {
                    this.loadingInstances = true;
                    this.payloadTasks.taskAndInstanceFilterModel.applicationId = this.getCurrentApplicationId;
                    this.payloadTasks.taskAndInstanceFilterModel.processDefinitionId = this.selectedProcess.id;
                    if (this.payloadTasks.hasOwnProperty("bulkSpecifications")) {
                        delete this.payloadTasks.bulkSpecifications;
                    }
                    if (!this.executedOnSearch) {
                        if (this.selectedPluginUuid) {
                            this.payloadTasks.taskAndInstanceFilterModel.activityIds = [this.selectedPluginUuid];
                        } else {
                            this.payloadTasks.taskAndInstanceFilterModel.activityIds = [];
                        }
                    }

                    if (this.instancesPagination.size) {
                        this.payloadTasks.size = this.instancesPagination.size;
                        if (resetPage) {
                            this.instancesPagination.page = 0;
                        }
                        this.payloadTasks.page = this.instancesPagination.page;
                    } else {
                        this.payloadTasks.size = 10;
                        this.payloadTasks.page = 0;
                    }
                    if (this.isSearchPage && this.tasksInstExData && this.tasksInstExData.perspectiveTasksStatus) {
                        this.payloadTasks.taskAndInstanceFilterModel.taskStatus = this.tasksInstExData.perspectiveTasksStatus;
                    }
                    this.hasStatusPreferences = false;
                    if (this.noTriggerAction) {
                        this.noTriggerAction = false;
                        this.resetCurrentPageInstances = false;
                        this.stopLoading("loadingInstances");
                    } else {
                        const customPayload = { pageType: this.pageType, payload: this.payloadTasks };
                        this.getAllInstances(customPayload).then(
                            data => {
                                if (data.data.totalCount === 0 && fromSearchContainer && !this.clearFilters) {
                                    this.searchAction = false;
                                }
                                this.preferencesError = false;
                                this.triggerOnSearch = false;
                                this.counterInstances = data.data.totalCount;
                                this.instancesTotalPages = data.data.totalPages;
                                this.instancesData = data.data.instanceModelList.map(element => {
                                    if (element.dataModelFields) {
                                        element = { ...element, ...this.extractDataModelInfo(element.dataModelFields) };
                                    }
                                    return element;
                                });
                                this.executedOnSearch = false;
                                this.resetCurrentPageInstances = false;
                                if (refreshData) {
                                    this.instancesColumns = refreshData;
                                }
                                this.stopLoading("loadingInstances");
                            }
                        )
                            .catch(({ response = {} }) => {
                                const { data: { status } = {} } = response;
                                if (status === 401) {
                                    this.$emit("checkPermission");
                                } else if (status === 409 && !this.preferencesError) {
                                    this.$toast.showNotify({
                                        type: "error",
                                        code: "filter-loadFail",
                                        message: this.$t("searchPerspectives.loadFilterError")
                                    });
                                }
                            });
                        const checkTabs = () => {
                            let noAccess;
                            if (this.isSearchPage) {
                                noAccess = this.tabsConfig.length === 1;
                            }
                            return !noAccess;
                        };

                        if (this.callOnSearch && checkTabs()) {
                            this.getTasksTotalCounter(customPayload).then(
                                data => {
                                    this.counterTasks = data;
                                    this.preferencesError = false;
                                }
                            )
                                .catch(({ response = {} }) => {
                                    const { data: { status } = {} } = response;
                                    if (status === 401) {
                                        this.$emit("checkPermission");
                                    } else if (status === 409 && !this.preferencesError) {
                                        this.$toast.showNotify({
                                            type: "error",
                                            code: "filter-loadFail",
                                            message: this.$t("searchPerspectives.loadFilterError")
                                        });
                                    }
                                });
                        }
                    }
                } else {
                    this.checkForSortPreferences("instances", this.instancesPageName);
                }
            }
        }, 0),
        checkForSortPreferences(type, interfaceName) {
            const payload = {
                interfaceName,
                pageType: this.pageType,
                perspectiveId: this.hasExternalData ? this.perspectiveId : "",
                appId: this.getCurrentApplicationId
            };
            this.getReportsSortPreferences(payload).then(
                data => {
                    let newData; const
                        isEndPoint = this.selectedPluginConfigData.pluginType === "GENERAL_END_PLUGIN";
                    const allowSorting = this.isSearchPage ? this.tasksInstExData.allowSorting : true;
                    if (isEndPoint && type === "instances") {
                        const { columns, columnsWithTypes } = data || {};
                        newData = {
                            sortBy: allowSorting ? "completionDate" : "",
                            sortType: allowSorting ? "DESC" : "",
                            columns: columns || [],
                            columnsWithTypes: columnsWithTypes || []
                        };
                    }
                    const checkAllowPreferences = this.isSearchPage ? this.tasksInstExData.allowSettings : true;
                    const checkForData = () => {
                        const { columns, columnsWithTypes, sortBy, sortType } = data || {};
                        return (columns && columns.length) || columnsWithTypes || sortBy || sortType;
                    };

                    if (checkForData()) {
                        if (checkAllowPreferences) {
                            const getValue = (v) => {
                                const { [v]: sortData } = newData || data;
                                return allowSorting ? sortData : null;
                            };
                            const getType = type === "tasks" ? "tasksColumns" : "instancesColumns";
                            const getDMList = (v) => v.filter((elem, index) => {
                                const isAvailable = elem.type;
                                if (isAvailable) {
                                    elem.index = index;
                                }
                                return isAvailable;
                            });
                            const hasDMToPreferences = this.isSearchPage ? getDMList(this.tasksInstExData[getType]) : [];
                            const { sortBy, sortType, columnsWithTypes } = newData || data;
                            const dmToAdd = [];
                            let columnsContainerToAdd;
                            const checkDefaultDM = () => {
                                const newPreferences = JSON.parse(JSON.stringify(this.tasksInstExData[getType]));
                                let hasElemRemoved;
                                hasDMToPreferences.forEach(elem => {
                                    let selectedIndex;
                                    const newDM = columnsWithTypes.find(({ column }, index) => {
                                        const existedCol = column === elem.value;
                                        if (existedCol) { selectedIndex = index; }
                                        return existedCol;
                                    });
                                    if (newDM) {
                                        if (!elem.visible) {
                                            columnsWithTypes.splice(selectedIndex, 1);
                                            hasElemRemoved = true;
                                        }
                                    } else if (elem.visible) {
                                        const selectedElem = newPreferences[elem.index];
                                        dmToAdd.push({
                                            column: selectedElem.value,
                                            columnName: selectedElem.label,
                                            dataType: selectedElem.dataType || null,
                                            type: selectedElem.type || null,
                                            visible: false
                                        });
                                    }
                                });
                                return dmToAdd.length || hasElemRemoved;
                            };
                            const resetSortingPreferences = (v) => {
                                if (v) {
                                    this[`${type}SortPreferences`].columnsWithTypes = columnsWithTypes || [];
                                    this.saveSortPreferences(this[`${type}SortPreferences`], interfaceName, true, true);
                                }
                            };

                            const setNewPreferences = (v) => {
                                this[`${type}SortPreferences`].sortBy = getValue("sortBy");
                                this[`${type}SortPreferences`].sortType = getValue("sortType");
                                this[`${type}SortPreferences`].columns = newData ? newData.columns : (data.columns || []);
                                if (!v) {
                                    this.setInitialSort(type, data, newData);
                                }
                            };

                            const checkForExtraColsAdmin = (v) => {
                                const availableColsPreferences = this.tasksInstExData[getType].filter(colDef => colDef.visible);
                                const defaultColsVal = availableColsPreferences.filter(colEl => (!colEl.type
                                                        && colEl.visible && colEl.value !== "more")).map(columnV => columnV.value);
                                const filteredNewCols = (v || columnsWithTypes).filter(prefCol => {
                                    const checkCol = () => {
                                        const index = defaultColsVal.indexOf(prefCol.column);
                                        let isAvailable;
                                        if (index !== -1) {
                                            isAvailable = true;
                                            defaultColsVal.splice(index, 1);
                                        }
                                        return prefCol.column === "more" || isAvailable;
                                    };
                                    return prefCol.type || checkCol();
                                });
                                if (defaultColsVal.length || columnsWithTypes.length !== filteredNewCols.length) {
                                    columnsContainerToAdd = { defaultColsVal, filteredNewCols };
                                }
                                return columnsContainerToAdd;
                            };
                            const getExtraColsData = () => {
                                const allDefaultCols = type === "tasks" ? TABLE_TASKS_CONFIG : TABLE_INSTANCES_CONFIG;
                                const addNewCols = [];
                                const { defaultColsVal } = columnsContainerToAdd;
                                defaultColsVal.forEach(colToAdd => {
                                    const getColToAdd = allDefaultCols.find(defCol => defCol.name === colToAdd);
                                    if (getColToAdd) {
                                        addNewCols.push({
                                            column: getColToAdd.name,
                                            columnName: getColToAdd.label,
                                            dataType: null,
                                            type: null,
                                            visible: false
                                        });
                                    }
                                });
                                return addNewCols;
                            };
                            if (hasDMToPreferences.length && !this.tasksInstExData.allowUseSettingsModel && checkDefaultDM()) {
                                let newColsPref;
                                const onlyDMValList = hasDMToPreferences.map(({ value }) => value);
                                let cleanedColumns = columnsWithTypes.filter(({ dataType, column }) => !dataType || onlyDMValList.includes(column));
                                if (checkForExtraColsAdmin(cleanedColumns)) {
                                    cleanedColumns = [...getExtraColsData(), ...columnsContainerToAdd.filteredNewCols];
                                }
                                if (type === "tasks") {
                                    const [last, ...rest] = cleanedColumns.reverse();
                                    newColsPref = [...rest.reverse(), ...dmToAdd, last];
                                } else {
                                    newColsPref = [...cleanedColumns, ...dmToAdd];
                                }
                                this[`${type}SortPreferences`].columnsWithTypes = newColsPref;
                                setNewPreferences(true);
                                this.saveSortPreferences(this[`${type}SortPreferences`], interfaceName, true, true);
                            } else if (this.tasksInstExData && this.tasksInstExData.allowSettings && checkForExtraColsAdmin()) {
                                this[`${type}SortPreferences`].columnsWithTypes = [...getExtraColsData(), ...columnsContainerToAdd.filteredNewCols];
                                setNewPreferences(true);
                                this.saveSortPreferences(this[`${type}SortPreferences`], interfaceName, true, true);
                            } else {
                                const resetSortingCase = !allowSorting && (sortBy || sortType);
                                setNewPreferences(resetSortingCase);
                                resetSortingPreferences(resetSortingCase);
                            }
                        } else {
                            this.saveSortPreferences({}, interfaceName, true, true);
                        }
                    } else {
                        this.setInitialSort(type, newData);
                    }
                },
                () => {
                    this.setInitialSort(type);
                }
            );
        },
        setInitialSort(type, savedData, newData) {
            const data = newData || savedData;
            const allowSorting = this.isSearchPage ? this.tasksInstExData.allowSorting : true;
            const getValue = (v) => {
                const { [v]: sortData } = data;
                return allowSorting ? sortData : null;
            };
            const dmFromPreferences = [];
            if (data && data.columnsWithTypes && data.columnsWithTypes.length) {
                const noDMCasesearch = this.isSearchPage ? !this.tasksInstExData.allowUseSettingsModel : false;
                if (type === "tasks") {
                    this.tasksColumns = [...this.setNewOrderColumnsOnLoad(data.columnsWithTypes, "tasksColumns", noDMCasesearch, dmFromPreferences)];
                } else {
                    this.instancesColumns = [...this.setNewOrderColumnsOnLoad(data.columnsWithTypes, "instancesColumns", noDMCasesearch, dmFromPreferences)];
                }
            }
            if (!this.isSearchPage || !dmFromPreferences.length) {
                this[`${type}InitialSort`] = data ? { descending: getValue("sortType") === "DESC",
                    sortBy: getValue("sortBy"),
                    columns: data.columns || [] } : {};
                this[`${type}GetTabData`]();
            }
        },
        setNewOrderColumnsOnLoad(savedColumns, initialColumns, removeDataModel, dmFromPreferences) {
            const allColumns = [];
            const getDMList = (v) => v.filter(elem => elem.type).map(({ value }) => value);
            const caseSearchDM = removeDataModel ? getDMList(this.tasksInstExData[initialColumns]) : [];
            savedColumns.forEach(elem => {
                if (elem.type) {
                    const isDataModel = elem.type === "DATA_MODEL";
                    const elemColumn = elem.column || elem.value;
                    const fieldValue = elemColumn.replace((isDataModel ? "m_" : "s_"), "");
                    const newColumn = {
                        type: isDataModel ? "MOD" : "VAR",
                        dataModelType: true,
                        dataType: elem.dataType || null,
                        typeFormatted: elemColumn,
                        align: elem.dataType === "string" ? "left" : "right",
                        field: fieldValue,
                        name: elemColumn,
                        label: elem.columnName || elem.label,
                        sortable: false,
                        visible: elem.visible,
                        style: "width:1%"
                    };

                    const checkToAddDM = (this.isSearchPage && (caseSearchDM.length || removeDataModel)) ? caseSearchDM.includes(elemColumn) : true;

                    if (checkToAddDM) {
                        allColumns.push(newColumn);
                    } else if (dmFromPreferences) {
                        dmFromPreferences.push(newColumn);
                    }
                } else {
                    const column = this[initialColumns].find(item => item.name === (elem.column || elem.value));
                    if (column) {
                        column.visible = elem.visible;
                        if (this.hasExternalData) {
                            column.sortable = this.tasksInstExData.allowSorting ? DEFAULT_SORT_COLUMNS.includes(column.name) : false;
                        }
                        allColumns.push(column);
                    }
                }
            });
            if (this.isSearchPage && dmFromPreferences && dmFromPreferences.length) {
                let interfaceName;
                let newCols;
                const cols = allColumns.map(elem => {
                    const setType = elem.type === "MOD" ? "DATA_MODEL" : "SYSTEM_VARIABLE";
                    return {
                        column: elem.dataModelType ? elem.typeFormatted : elem.name,
                        columnName: elem.label,
                        dataType: elem.dataType || null,
                        type: elem.dataModelType ? setType : null,
                        visible: !!(elem.required || elem.visible)
                    };
                });
                const getDefaultCols = () => {
                    caseSearchDM.forEach(elem => {
                        const defaultElem = cols.find(({ column }) => column === elem);
                        if (!defaultElem) {
                            const newElem = this.tasksInstExData[initialColumns].filter(({ value }) => value === elem).map(e => ({ column: e.value,
                                columnName: e.label,
                                dataType: e.dataType || null,
                                type: e.type || null,
                                visible: (e.required || e.visible) }));
                            const [first] = newElem || [];
                            if (first) {
                                cols.splice(cols.length - 1, 0, first);
                            }
                        }
                    });
                };
                if (initialColumns === "tasksColumns") {
                    interfaceName = this.tasksPageName;
                    getDefaultCols();
                    this.tasksSortPreferences.columnsWithTypes = cols;
                    newCols = this.tasksSortPreferences;
                } else {
                    interfaceName = this.instancesPageName;
                    getDefaultCols();
                    this.instancesSortPreferences.columnsWithTypes = cols;
                    newCols = this.instancesSortPreferences;
                }
                this.saveSortPreferences(newCols, interfaceName, true, true);
            }
            return allColumns;
        },
        setTabExtraData(newValue, type) {
            const { data, totalCount, totalPages } = newValue;
            const capitalizeTest = (v) => v.charAt(0).toUpperCase() + v.slice(1);
            this[`counter${capitalizeTest(type)}`] = totalCount || 0;
            this[`${type}TotalPages`] = totalPages || 0;
            this[`${type}Data`] = [...data] || [];
        },
        setCustomPreferences(value) {
            const getData = (type) => {
                const sortByColumn = type === "tasks" ? "taskName" : "instanceName";
                return {
                    descending: false,
                    sortBy: value ? sortByColumn : "",
                    columns: []
                };
            };
            this.customTasksSort = getData("tasks");
            this.customInstancesSort = getData("instances");
        }
    }
};
